import { AppLoading } from 'components/app-loading';
import { PageLoader } from 'components/page-loader';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import React, { memo, useEffect } from 'react';
import { actionAccountCheckAuth, selectAccountState } from 'store/auth';

interface Props {
  children: React.ReactNode;
}
export const AuthProvider = memo<Props>(({ children }) => {
  const { isInit, isLoading } = useAppSelector(selectAccountState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (isInit) return;

    const result = dispatch(actionAccountCheckAuth());

    return () => {
      result.abort();
    };
  }, [isInit, dispatch]);

  return (
    <>
      {isInit && children}
      {isLoading && (isInit ? <AppLoading /> : <PageLoader />)}
    </>
  );
});
